import api from '@/apis'

export const queryBannerList = (params) => api.get(`/banner/list`, { params });
export const addBanner = (data) => api.post(`/banner/add`, data)
export const updateBanner = (data) => api.put(`/banner/edit`, data)
export const deleteBanner = (id) => api.delete(`/banner/delete/${id}`)